var map = {
	"./AdGuardDnsInfo.vue": [
		"f258",
		"chunk-4c6c9844"
	],
	"./AdGuardFilterStatus.vue": [
		"6750",
		"chunk-47b064fc"
	],
	"./AdGuardStats.vue": [
		"4aa6",
		"chunk-50f31ec3",
		"chunk-284f6914"
	],
	"./AdGuardTopDomains.vue": [
		"72ed",
		"chunk-ec7f79ce"
	],
	"./AnonAddy.vue": [
		"a492",
		"chunk-03c5a0ba"
	],
	"./Apod.vue": [
		"64ab",
		"chunk-0168c5de"
	],
	"./BlacklistCheck.vue": [
		"b5ef",
		"chunk-417fcdd6"
	],
	"./Blank.vue": [
		"c16a",
		"chunk-d8e568e8"
	],
	"./ChuckNorris.vue": [
		"0a33",
		"chunk-04aafaca"
	],
	"./Clock.vue": [
		"5e2a",
		"chunk-e61b5320"
	],
	"./CodeStats.vue": [
		"d7a5",
		"chunk-50f31ec3",
		"chunk-aa9cebcc"
	],
	"./CovidStats.vue": [
		"714f",
		"chunk-50f31ec3",
		"chunk-aded91e2"
	],
	"./CryptoPriceChart.vue": [
		"679e",
		"chunk-50f31ec3",
		"chunk-75cc9f4d"
	],
	"./CryptoWatchList.vue": [
		"c772",
		"chunk-4c0e4e0e"
	],
	"./CustomList.vue": [
		"dcd8",
		"chunk-a625828e"
	],
	"./CustomSearch.vue": [
		"8e89",
		"chunk-1ac1d92c"
	],
	"./CveVulnerabilities.vue": [
		"c632",
		"chunk-b97092de"
	],
	"./DomainMonitor.vue": [
		"3bae",
		"chunk-48d3a404"
	],
	"./DroneCi.vue": [
		"ebe5",
		"chunk-4019f9ad"
	],
	"./EmbedWidget.vue": [
		"ec79",
		"chunk-34536cd9"
	],
	"./EthGasPrices.vue": [
		"91f0",
		"chunk-50f31ec3",
		"chunk-14192a80"
	],
	"./ExchangeRates.vue": [
		"a65f",
		"chunk-1b5c6f46"
	],
	"./Flights.vue": [
		"a75b",
		"chunk-7ebd6aae"
	],
	"./GitHubProfile.vue": [
		"e160",
		"chunk-2b85636c"
	],
	"./GitHubTrending.vue": [
		"3134",
		"chunk-5746d138"
	],
	"./GlAlerts.vue": [
		"6193",
		"chunk-463ff8ec"
	],
	"./GlCpuCores.vue": [
		"3237",
		"chunk-609695f0"
	],
	"./GlCpuGauge.vue": [
		"9304",
		"chunk-176b9a81"
	],
	"./GlCpuHistory.vue": [
		"0949",
		"chunk-50f31ec3",
		"chunk-101c08c4"
	],
	"./GlCpuSpeedometer.vue": [
		"29f0",
		"chunk-40d7341a"
	],
	"./GlCpuTemp.vue": [
		"6134",
		"chunk-2e142706"
	],
	"./GlDiskIo.vue": [
		"35a8",
		"chunk-ac74face"
	],
	"./GlDiskSpace.vue": [
		"1f55",
		"chunk-406d5fa8"
	],
	"./GlIpAddress.vue": [
		"82d1",
		"chunk-00fe3e02"
	],
	"./GlLoadHistory.vue": [
		"ce80",
		"chunk-50f31ec3",
		"chunk-0ed625ed"
	],
	"./GlMemGauge.vue": [
		"2af9",
		"chunk-6ebc8882"
	],
	"./GlMemHistory.vue": [
		"dccf",
		"chunk-50f31ec3",
		"chunk-7123143f"
	],
	"./GlMemSpeedometer.vue": [
		"8f1b",
		"chunk-c292845c"
	],
	"./GlNetworkInterfaces.vue": [
		"4558",
		"chunk-e60f3442"
	],
	"./GlNetworkTraffic.vue": [
		"bf13",
		"chunk-50f31ec3",
		"chunk-30ba9057"
	],
	"./GlSystemLoad.vue": [
		"7ce6",
		"chunk-50f31ec3",
		"chunk-e47632fa"
	],
	"./GluetunStatus.vue": [
		"4841",
		"chunk-617c9aad"
	],
	"./HackernewsTrending.vue": [
		"2213",
		"chunk-0ee89062"
	],
	"./HealthChecks.vue": [
		"dac2",
		"chunk-4c08cd58"
	],
	"./IframeWidget.vue": [
		"2386",
		"chunk-ecefee06"
	],
	"./ImageWidget.vue": [
		"2356",
		"chunk-35ae5203"
	],
	"./Jokes.vue": [
		"7b50",
		"chunk-617be804"
	],
	"./Linkding.vue": [
		"7b54",
		"chunk-43e986b4"
	],
	"./MinecraftStatus.vue": [
		"0723",
		"chunk-ff36d670"
	],
	"./MullvadStatus.vue": [
		"1e8e",
		"chunk-77932881"
	],
	"./Mvg.vue": [
		"c9a3",
		"chunk-511993b4"
	],
	"./MvgConnection.vue": [
		"ba75",
		"chunk-6a1d9e3e"
	],
	"./NdCpuHistory.vue": [
		"e641",
		"chunk-50f31ec3",
		"chunk-2ab49ff8"
	],
	"./NdLoadHistory.vue": [
		"47ad",
		"chunk-50f31ec3",
		"chunk-d42744f4"
	],
	"./NdRamHistory.vue": [
		"1afb",
		"chunk-50f31ec3",
		"chunk-0c51289a"
	],
	"./NewsHeadlines.vue": [
		"f406",
		"chunk-0ac26b47"
	],
	"./NextcloudNotifications.vue": [
		"f48c",
		"chunk-700930a9"
	],
	"./NextcloudPhpOpcache.vue": [
		"8eac",
		"chunk-61a696f4"
	],
	"./NextcloudStats.vue": [
		"f9cc",
		"chunk-5d83ccdd"
	],
	"./NextcloudSystem.vue": [
		"2f96",
		"chunk-50f31ec3",
		"chunk-445b2f7e"
	],
	"./NextcloudUser.vue": [
		"f298",
		"chunk-7111bf39"
	],
	"./NextcloudUserStatus.vue": [
		"2937",
		"chunk-648f8426"
	],
	"./PiHoleStats.vue": [
		"3ce5",
		"chunk-50f31ec3",
		"chunk-c240e74e"
	],
	"./PiHoleStatsV6.vue": [
		"f489",
		"chunk-50f31ec3",
		"chunk-8849ca68"
	],
	"./PiHoleTopQueries.vue": [
		"7309",
		"chunk-d59d0b26"
	],
	"./PiHoleTopQueriesV6.vue": [
		"9029",
		"chunk-364a4a7f"
	],
	"./PiHoleTraffic.vue": [
		"e61b",
		"chunk-50f31ec3",
		"chunk-2d225b78"
	],
	"./PiHoleTrafficV6.vue": [
		"2be7",
		"chunk-50f31ec3",
		"chunk-2d0bd7d8"
	],
	"./Proxmox.vue": [
		"8715",
		"chunk-ab295e8e"
	],
	"./PublicHolidays.vue": [
		"79b9",
		"chunk-5fdf99a2"
	],
	"./PublicIp.vue": [
		"4f0c",
		"chunk-000f2aac"
	],
	"./RescueTime.vue": [
		"1b90",
		"chunk-914b1eb6"
	],
	"./RssFeed.vue": [
		"4f87",
		"chunk-3f189c99"
	],
	"./Sabnzbd.vue": [
		"2e26",
		"chunk-4619df14"
	],
	"./SportsScores.vue": [
		"7fa8",
		"chunk-60a18d06"
	],
	"./StatPing.vue": [
		"d71a",
		"chunk-59a58476"
	],
	"./StockPriceChart.vue": [
		"b1f5",
		"chunk-50f31ec3",
		"chunk-1e169674"
	],
	"./SynologyDownload.vue": [
		"5a4b",
		"chunk-4aa50786"
	],
	"./SystemInfo.vue": [
		"0021",
		"chunk-50f31ec3",
		"chunk-0387fd77"
	],
	"./TacticalRMM.vue": [
		"93a5",
		"chunk-fb06290a"
	],
	"./TflStatus.vue": [
		"5d62",
		"chunk-8fcef2dc"
	],
	"./UptimeKuma.vue": [
		"709a",
		"chunk-386e41bc"
	],
	"./UptimeKumaStatusPage.vue": [
		"1e46",
		"chunk-5a545b03"
	],
	"./WalletBalance.vue": [
		"6d7b",
		"chunk-7b1342c4"
	],
	"./Weather.vue": [
		"048f",
		"chunk-7bf02968"
	],
	"./WeatherForecast.vue": [
		"d76f",
		"chunk-8f8d9d38"
	],
	"./WidgetBase.vue": [
		"2955"
	],
	"./XkcdComic.vue": [
		"a2e3",
		"chunk-1dff51ed"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "50ed";
module.exports = webpackAsyncContext;